<template>
    <div class="flats-crm-topbar">
        <div class="btns-cards-view-mobile">
            <div class="btns">
                <div class="item" :class="{active: gridView}">
                    <a href="#" class="btn-view-item btn-view-grid btn-change-cards-view" @click.prevent="setGridView(true)">
                        <svgIcon name="grid" />
                    </a>
                </div>
                <div class="item" :class="{active: !gridView}">
                    <a href="#" class="btn-view-item btn-view-list btn-change-cards-view" @click.prevent="setGridView(false)">
                        <svgIcon name="list" />
                    </a>
                </div>
            </div>
        </div>
        <div class="filter-link">
            <a href="#" @click.prevent="openFilterWindow">
                <svgIcon name="filter" />
                <span>Фильтр</span>
            </a>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-CRM-flats-topbar',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            filterVisible: 'loadVisibleFilterMobile',
			gridView: 'loadLandFlatsGridView',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            setGridView(param) { 
				this.$store.commit('gridView', param);
            },
            openFilterWindow() {
                window.body.addClass('overflowTrue');
				document.getElementById('header').classList.add('notvisible');
                document.getElementById('footer').classList.add('notvisible');
				this.$store.commit('SetVisibleFilterMobile', true);
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.setGridView(false);
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/respond/flats-crm-topbar.scss';
</style>